import API from './API.js';
export default class MasterEditorFormat extends API {
    constructor() {
        super('masterEditorFormat');
    }

}
